import NewspaperNotificationRangesSelect from './NewspaperNotificationRangesSelect'
export default NewspaperNotificationRangesSelect
